<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">画像個別登録</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">画像ファイル</label>
            <div class="list-input-content">
              <input type="text" id="txti_ImageFile" class="text-label-required input-with-button" readonly="true"
                [(ngModel)]="kymw1704Model.imageFile" [tabindex]="0" plessInputTextSub [restrict]="'[ -￮]'">
              <button id="btn_Image" class="btn-secondary" (click)="eventImage_ClickHandler()" [tabindex]="0">選択</button>
            </div>

            <label class="list-input-title">使用受注コード</label>
            <div class="list-input-content">
              <div class="element-row">
                <app-order-code-text-input id="txt_StartOrderCode" #txt_StartOrderCode [subid]="'txt_StartOrderCode'"
                  style="width:initial" [catalogIDField]="txti_startOrderDelivCatalogID" [tabindex]="0"
                  [required]="true" [(ngModel)]="kymw1704Model.startOrderCode"
                  (ngModelChange)="eventStartOrderCode_ChangedHandler()"></app-order-code-text-input>
                <label>～</label>
                <app-order-code-text-input id="txt_EndOrderCode" #txt_EndOrderCode [subid]="'txt_EndOrderCode'"
                  style="width:initial" [catalogIDField]="txti_endOrderDelivCatalogID" [tabindex]="0"
                  [disabled]="!kymw1704Model.endOrderCodeEnabled"
                  [(ngModel)]="kymw1704Model.endOrderCode"></app-order-code-text-input>
                <app-checkbox-label id="chk_EndOrderNothing" #chk_EndOrderNothing [subid]="'chk_EndOrderNothing'"
                  label="無制限" [tabindex]="0" [(ngModel)]="kymw1704Model.endOrderNothing"
                  (change)="eventEndOrderNothing_CheckHandler()" style="display:flex; align-items:center;">
                </app-checkbox-label>
              </div>
            </div>

            <label class="list-input-title">使用配達企画回(翌週)</label>
            <div class="list-input-content">
              <div class="element-row">
                <input type="text" class="deliv-catalog" id="txti_startOrderDelivCatalogID"
                  #txti_startOrderDelivCatalogID readonly plessInputTextSub [restrict]="'[ -￮]'">
                <label>～</label>
                <input type="text" class="deliv-catalog" id="txti_endOrderDelivCatalogID"
                  #txti_endOrderDelivCatalogID readonly plessInputTextSub [restrict]="'[ -￮]'">
                <app-checkbox-label id="chk_EndOrderEqual" #chk_EndOrderEqual [subid]="'chk_EndOrderEqual'" label="今回のみ"
                  [tabindex]="0" [(ngModel)]="kymw1704Model.endOrderEqual" (change)="eventEndOrderEqual_CheckHandler()" style="display:flex; align-items:center;">
                </app-checkbox-label>
              </div>
            </div>
          </div>

          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">画像名</label>
              <div class="list-input-content">
                <input id="txti_ImageName" type="text" readonly
                  style="width: 225px;" [(ngModel)]="kymw1704Model.imageName"
                  plessInputTextSub [restrict]="'[ -￮]'">
                <button id="btn_ImageNameSeach" #btn_ImageNameSeach [tabindex]="0" class="btn-secondary"
                  (click)="eventImageNameSeach_ClickHandler()">画像名設定</button>
              </div>

              <label style="visibility: collapse;">dummy</label>
              <label style="visibility: collapse;">dummy</label>

              <label class="list-input-title">所属</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_ImageBelongID" #cmb_ImageBelongID [subid]="'cmb_ImageBelongID'"
                  [required]="true" [codeDiv]="'ct365'" [tabindex]="0" [labelField]="'codeValueName'"
                  [(ngModel)]="kymw1704Model.imageBelongID">
                </app-code-combo-box>
              </div>

              <label class="list-input-title">画像種類</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_ImageKind" #cmb_ImageKind [subid]="'cmb_ImageKind'" [required]="true"
                  [codeDiv]="'ct366'" [tabindex]="0" [labelField]="'codeValueName'" [(ngModel)]="kymw1704Model.imageKind">
                </app-code-combo-box>
              </div>

              <label class="list-input-title">画像種別</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_ImageType" #cmb_ImageType [subid]="'cmb_ImageType'" [required]="true"
                  [codeDiv]="'ct367'" [labelField]="'codeValueName'" [tabindex]="0" [(ngModel)]="kymw1704Model.imageType"
                  (change)="eventImageType_ChangedHandler()"></app-code-combo-box>
              </div>

              <label class="list-input-title">調理指示</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_ProcessInstruct" #cmb_ProcessInstruct [subid]="'cmb_ProcessInstruct'"
                  [codeDiv]="'ct368'" [tabindex]="0" [labelField]="'codeValueName'" [required]="true"
                  [(ngModel)]="kymw1704Model.processInstruct" [disabled]="!kymw1704Model.processInstructEnabled">
                </app-code-combo-box>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">画像ファイル名</label>
              <div class="list-input-content">
                <input id="txti_ImageFileName" type="text" plessInputTextSub
                  [restrict]="'[ -￮]'" [(ngModel)]="kymw1704Model.imageFileName" readonly>
              </div>

              <label class="list-input-title">Ｐコード</label>
              <div class="list-input-content">
                <input type="text" id="txti_PCode" class="pcode" [maxlength]="8" [tabindex]="0" plessInputTextSub [restrict]="'[P0-9]'"
                  [(ngModel)]="kymw1704Model.pCode" (change)="eventPCode_ChangedHandler()">
              </div>

              <label class="list-input-title">商品案内用商品名</label>
              <div class="list-input-content">
                <input type="text" id="txti_GuideGoodsName" class="guide-goods-name"
                  [(ngModel)]="kymw1704Model.guideGoodsName" readonly>
              </div>

              <label class="list-input-title">商品案内用規格名</label>
              <div class="list-input-content">
                <input type="text" id="txti_GuideStandardName" class="guide-standard-name"
                  [(ngModel)]="kymw1704Model.guideStandardName" readonly>
              </div>

              <label class="list-input-title">備考</label>
              <div class="list-input-content">
                <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_Remarks" #txta_Remarks [subid]="'txta_Remarks'" style="width: 650px; height: 69px;"
                  [maxChars]="128" [tabindex]="0" [displayCountField]="false" [(ngModel)]="kymw1704Model.remarks">
                </app-text-area>
              </div>
            </div>
          </div>

          <div class="column-list" style="width: 820px;">
            <label class="list-input-title">調理例掲載区分</label>
            <div class="list-input-content">
              <app-checkbox-label id="chk_CookingExPublish" #chk_CookingExPublish [subid]="'chk_CookingExPublish'"
                [tabindex]="0" [(ngModel)]="kymw1704Model.cookingExPublish" label="掲載あり">
              </app-checkbox-label>
            </div>

            <label class="list-input-title">サンプル発注先コード</label>
            <div class="list-input-content">
              <input type="text" id="txti_SampleOrderingCode" style="width:7rem;"
                [maxlength]="6" plessInputTextSub [restrict]="'[0-9]'" [tabindex]="0"
                [(ngModel)]="kymw1704Model.sampleOrderingCode" (change)="eventSampleOrderingCode_ChangedHandler()">
              <button [tabindex]="0" class="btn-secondary" id="btn_SampleOrderingSeach"
                (click)="eventSamplePrderingSeach_ClickHandler()">検索</button>
              <input type="text" id="txti_SampleSupplierNameKanji"  readonly
                plessInputTextSub [restrict]="'[ -￮]'" [(ngModel)]="kymw1704Model.sampleSupplierNameKanji">
            </div>

            <label class="list-input-title">請求先コード</label>
            <div class="list-input-content">
              <input type="text" id="txti_BillingCode" style="width:7rem;" [maxlength]="6"
                plessInputTextSub [restrict]="'[0-9]'" [tabindex]="0" [(ngModel)]="kymw1704Model.billingCode"
                (change)="eventBillingCode_ChangedHandler()">
              <button id="btn_BillingSeach" [tabindex]="0" class="btn-secondary"
                (click)="eventBillingSeach_ClickHandler()">検索</button>
              <input type="text" id="txti_BillingSupplierNameKanji" readonly
                plessInputTextSub [restrict]="'[ -￮]'" [(ngModel)]="kymw1704Model.billingSupplierNameKanji">
            </div>

            <label class="list-input-title">請求対象</label>
            <div class="list-input-content">
              <app-checkbox-label id="chk_BillingTargetDiv" #chk_BillingTargetDiv [subid]="'chk_BillingTargetDiv'"
                label="対象" [tabindex]="0" [(ngModel)]="kymw1704Model.billingTargetDiv">
              </app-checkbox-label>
            </div>
          </div>

          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">料理分類</label>
              <div class="list-input-content" style="width: 22rem;">
                <app-code-combo-box id="cmb_CookingDiv" #cmb_CookingDiv [subid]="'cmb_CookingDiv'" [codeDiv]="'ct369'"
                  [tabindex]="0" [labelField]="'codeValueName'" [(ngModel)]="kymw1704Model.cookingDiv">
                </app-code-combo-box>
              </div>

              <label class="list-input-title">材料名</label>
              <div class="list-input-content">
                <app-text-input id="txti_MaterialName" #txti_MaterialName [subid]="'txti_MaterialName'" [restrict]="'[ -￮]'"
                   [fullOnly]="true" [maxChars]="20" [displayCountField]="false" [(ngModel)]="kymw1704Model.materialName" [tabindex]="0">
                </app-text-input>
              </div>

              <label class="list-input-title">季節・催事</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_EventID" #cmb_EventID [subid]="'cmb_EventID'" [codeDiv]="'ct370'" [tabindex]="0"
                  [labelField]="'codeValueName'" [(ngModel)]="kymw1704Model.eventID">
                </app-code-combo-box>
              </div>

              <label class="list-input-title">撮影内容区分</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_PhotoContentsDiv" #cmb_PhotoContentsDiv [subid]="'cmb_PhotoContentsDiv'"
                  [codeDiv]="'ct372'" [tabindex]="0" [labelField]="'codeValueName'"
                  [(ngModel)]="kymw1704Model.photoContentsDiv">
                </app-code-combo-box>
              </div>

              <label class="list-input-title">撮影予定日</label>
              <div class="list-input-content">
                <wj-input-date class="text-label-required" #dtf_PhotoSchedule id="dtf_PhotoSchedule"
                  format="yyyy/MM/dd" [isRequired]="false" [tabindex]="0" [min]="minDate" [max]="maxDate"
                  [(text)]="kymw1704Model.photoSchedule"></wj-input-date>
              </div>

              <label class="list-input-title">撮影場所</label>
              <div class="list-input-content">
                <app-studio-master-combo-box id="cmb_PhotoStudioID" [subid]="'cmb_PhotoStudioID'" [tabindex]="0"
                  [required]="true" [(ngModel)]="kymw1704Model.studioId">
                </app-studio-master-combo-box>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">料理名</label>
              <div class="list-input-content" style="width: 22rem;">
                <app-text-input id="txti_CookingName" #txti_CookingName [subid]="'txti_CookingName'" [restrict]="'[ -￮]'"
                   [fullOnly]="true" [maxChars]="20" [tabindex]="0" [displayCountField]="false" [(ngModel)]="kymw1704Model.cookingName">
                </app-text-input>
              </div>

              <label class="list-input-title">キーワード</label>
              <div class="list-input-content">
                <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txti_KeyWord" #txti_KeyWord [subid]="'txti_KeyWord'" style="height: 68.5px;"
                  [maxChars]="128" [displayCountField]="false" [(ngModel)]="kymw1704Model.keyWord" [tabindex]="0">
                </app-text-area>
              </div>

              <label class="list-input-title">画像キャプション</label>
              <div class="list-input-content" style="width: 52rem;">
                <app-text-input id="txti_Caption" #txti_Caption [subid]="'txti_Caption'" [fullOnly]="true"
                  [restrict]="'[ -￮]'" [maxChars]="50" [tabindex]="0" [displayCountField]="false"
                  [(ngModel)]="kymw1704Model.textCaption">
                </app-text-input>
              </div>

              <label class="list-input-title">撮影指示内容</label>
              <div class="list-input-content">
                <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_PhotoInstructContents" #txta_PhotoInstructContents
                  [subid]="'txta_PhotoInstructContents'" [maxChars]="128" [tabindex]="0" [displayCountField]="false"
                  [(ngModel)]="kymw1704Model.photoInstructContents" style="height: 68.5px;">
                </app-text-area>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Update" class="btn-primary" (click)="eventUpdate_ClickHandler()" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_ClickHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>